module.exports = __webpack_public_path__ + "img/badge-highest-revenue-bronze.7b310982.png";